import { EmissionFactorEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { EmissionFactorEstimateResult } from '@lune-fe/lune-components-lib'
import { FC, RefObject, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { asSuccessResponseWithMeta } from 'endpoints/util'
import useIsTestMode from 'hooks/useIsTestMode'
import { useLuneClient } from 'hooks/useLuneClient'
import { getTestApiKey } from 'utils'
import { ResultsWrapper } from 'views/CalculateEmissions'

const EmissionFactorEstimateResults: FC<{ scrollRef: RefObject<HTMLDivElement> }> = ({
    scrollRef,
}) => {
    const { id } = useParams<{ id: string }>()
    const [estimate, setEstimate] = useState<SuccessResponseWithMeta<EmissionFactorEstimate>>()
    const luneClient = useLuneClient()
    const isTestMode = useIsTestMode()
    const testApiKey = getTestApiKey()

    useEffect(() => {
        if (id) {
            luneClient.getEmissionFactorEstimate(id).then((res) => {
                if (res.isOk()) {
                    const e = asSuccessResponseWithMeta(res.value)
                    setEstimate(e)
                }
            })
        }
    }, [id, luneClient])

    return (
        <>
            {estimate && (
                <ResultsWrapper scrollRef={scrollRef} calculatedAmount={estimate.mass.amount}>
                    <EmissionFactorEstimateResult
                        estimate={estimate}
                        enableEmissionFactorLink={true}
                        requestAndResponseSnippets={{ isTestMode, testApiKey }}
                    />
                </ResultsWrapper>
            )}
        </>
    )
}

export default EmissionFactorEstimateResults
